/**
 * Read more toggle for CGF Profile Cards bios (.js-profile-bio).
 * The bio is clamped by CSS from the start so cards never render tall; JS
 * reveals the toggle only when clamping actually hides text, and unclamps
 * bios short enough to fit.
 * Runs on window load, NOT DOMContentLoaded: the overflow measurement needs
 * the stylesheet applied, and DOMContentLoaded can fire before the CSS does.
 */
function cgfProfileReadmore() {
    document.querySelectorAll('.js-profile-bio').forEach((bio) => {
        const button = bio.parentElement.querySelector('.js-profile-more');
        if (!button) {
            return;
        }

        // Short bio: nothing hidden, no toggle needed
        if (bio.scrollHeight <= bio.clientHeight + 1) {
            bio.classList.add('profile-cards__bio--open');
            return;
        }

        const label = button.querySelector('.profile-cards__more-label');
        const cell  = button.closest('.cell');
        bio.classList.add('profile-cards__bio--clamped');
        button.hidden = false;
        button.addEventListener('click', () => {
            const open = bio.classList.toggle('profile-cards__bio--open');
            // Animate: the CSS transitions max-height, and none is not
            // animatable, so drive the open height with an inline pixel value
            bio.style.maxHeight = open ? bio.scrollHeight + 'px' : '';
            bio.classList.toggle('profile-cards__bio--clamped', !open);
            button.classList.toggle('profile-cards__more--open', open);
            button.setAttribute('aria-expanded', open ? 'true' : 'false');
            label.textContent = open ? 'Read less' : 'Read more';

            // Only the clicked card grows: freeze the neighbours at their
            // current height BEFORE the row reflows, so they neither stretch
            // with the new row height nor shrink to their natural height
            if (cell) {
                const grid = cell.parentElement;
                const cells = grid.querySelectorAll(':scope > .cell');

                if (open && !grid.classList.contains('profile-cards__grid--has-open')) {
                    cells.forEach((c) => {
                        if (c !== cell) {
                            c.style.height = c.getBoundingClientRect().height + 'px';
                        }
                    });
                }

                cell.classList.toggle('profile-cards__cell--open', open);
                cell.style.height = '';

                const hasOpen = !!grid.querySelector('.profile-cards__cell--open');

                if (hasOpen) {
                    grid.classList.add('profile-cards__grid--has-open');
                } else {
                    // Everything closed: release the frozen heights only after
                    // the collapse animation ends, otherwise the neighbours
                    // re-stretch mid-transition and the whole row moves
                    bio.addEventListener('transitionend', () => {
                        if (!grid.querySelector('.profile-cards__cell--open')) {
                            grid.classList.remove('profile-cards__grid--has-open');
                            cells.forEach((c) => {
                                c.style.height = '';
                            });
                        }
                    }, { once: true });
                }
            }
        });
    });
}

// Resize/orientation change: pixel heights fixed at the previous layout can
// cut open bios short, so recompute them and let frozen neighbours reflow
// to their natural clamped height at the new width
let cgfProfileResizeTimer;
window.addEventListener('resize', () => {
    clearTimeout(cgfProfileResizeTimer);
    cgfProfileResizeTimer = setTimeout(() => {
        document.querySelectorAll('.profile-cards__bio--open').forEach((bio) => {
            bio.style.maxHeight = bio.scrollHeight + 'px';
        });
        document
            .querySelectorAll('.profile-cards__grid--has-open > .cell:not(.profile-cards__cell--open)')
            .forEach((cell) => {
                cell.style.height = '';
            });
    }, 150);
});

if (document.readyState === 'complete') {
    cgfProfileReadmore();
} else {
    window.addEventListener('load', cgfProfileReadmore);
}
